import React from 'react';
import propTypes from 'prop-types';
import { intlShape } from 'react-intl';
import Markdown from 'markdown-to-jsx';

import { LinkExternalWithHref } from 'cstar-react-primitives/lib/redux-form/LinkExternalWithHref';

import consentMessages from './consentMessages';
import GDPRTermsAcknowledgementField from './GDPRTermsAcknowledgementField';

export const GDPRTermsAcknowledgement = ({
    format,
    id,
    className,
    intl
}) => {
    const implicitMarkdownMessage = intl.formatMessage(consentMessages.termsAcknowledgementImplicitMessage,
        {
            policyUrl: '/store/self_service/v2/about/privacy_policy',
            termsUrl: '/store/self_service/v2/about/terms_and_conditions'
        });

    switch (format) {
        case 'IMPLICIT':
            return (
                <div id={id} className={className}>
                    <Markdown
                        options={{
                            overrides: {
                                
                                a: {
                                    component: LinkExternalWithHref
                                }
                            }
                        }}
                    >
                        {implicitMarkdownMessage}
                    </Markdown>
                </div>
            );
        case 'EXPLICIT':
            return (<GDPRTermsAcknowledgementField />);
        default:
            return null;
    }
};

GDPRTermsAcknowledgement.defaultProps = {
    id: null,
    className: null
};

GDPRTermsAcknowledgement.propTypes = {
    format: propTypes.string.isRequired,
    id: propTypes.string,
    intl: intlShape.isRequired,
    className: propTypes.string
};
